import { Component, Input, OnInit } from '@angular/core';
import {
  ForgeCardModule,
  ForgeBadgeModule,
  ForgeExpansionPanelModule,
  ForgeLabelValueModule,
  ForgeDividerModule
} from '@tylertech/forge-angular';
import { Bond } from "@tylertech/cj-inmate-search-angular-sdk";
import { SharedModule } from "../../../../modules/shared/shared.module";
import { CurrencyPipe } from "@angular/common";
import { InstanceConfigService } from "../../../../core/services/instance-config.service";

export interface BondSetting {
  bondSettingId: number;
  bondSettingDate?: string;
  bondStatus?: string;
  bondCount: number;
  totalBondAmount?: number;
  depositAmount?: number;
  totalDue?: number;
  bondFees: Array<{ amount: number; description: string; type?: string | null }>;
  canDetermineBondFees: boolean;
}

@Component({
  selector: 'bond-details',
  standalone: true,
  templateUrl: './bond-details.component.html',
  styleUrls: ['./bond-details.component.scss'],
  imports: [
    ForgeCardModule,
    ForgeExpansionPanelModule,
    ForgeLabelValueModule,
    ForgeBadgeModule,
    ForgeDividerModule,
    SharedModule,
    CurrencyPipe
  ]
})
export class BondDetailsComponent implements OnInit {
  @Input() bond!: Bond;
  @Input() bondSettings: BondSetting[] = [];
  displayBondFees = false;

  // Find the bond setting for this bond
  get bondSetting(): BondSetting | undefined {
    const bondSettingId = (this.bond as any).bondSettingId;
    if (!bondSettingId) return undefined;
    return this.bondSettings.find(bs => bs.bondSettingId === bondSettingId);
  }

  // Determine if we should show fees on this bond
  // Fees are shown when there's a single bond per setting and we can determine them
  get shouldShowFeesOnBond(): boolean {
    const setting = this.bondSetting;
    if (!setting) return false;
    return setting.bondCount === 1 && setting.canDetermineBondFees;
  }

  // Determine if we should show "contact facility" message
  get shouldShowContactFacility(): boolean {
    const setting = this.bondSetting;
    if (!setting) return false;

    // Show message if multiple bonds per setting OR can't determine fees
    return setting.bondCount > 1 || !setting.canDetermineBondFees;
  }

  // Get bond fees from the bond setting
  get bondFees(): Array<{ amount: number; description: string; type?: string | null }> | undefined {
    const setting = this.bondSetting;
    if (!setting || !setting.bondFees || setting.bondFees.length === 0) {
      return undefined;
    }
    return setting.bondFees;
  }

  constructor(private readonly _instanceConfigService: InstanceConfigService) { }

  ngOnInit(): void {
    const visibility = this._instanceConfigService.inmateVisibilitySnapshot;
    this.displayBondFees = visibility?.displayBondFees ?? false;
  }

}